import { createApi } from '@reduxjs/toolkit/dist/query/react';
import {
  type IExportOrdersRequest,
  type IGetOrdersRequest,
  type IOrdersResponse,
  type TOrderUpdateBody,
  type TOrderUpdateStatusBody,
} from '../types/OrdersTypes';
import { TFile } from 'redux/types/WithdrawalsTypes';
import { baseQuery, getBaseQueryWithReauth } from 'redux/baseQueryAuth';

export const OrdersApi = createApi({
  reducerPath: 'OrdersApi',
  tagTypes: ['Orders'],
  baseQuery: getBaseQueryWithReauth(baseQuery),
  endpoints: (build) => ({
    getOrders: build.query<IOrdersResponse, IGetOrdersRequest>({
      query: (params) => ({
        params: {
          [(params?.status || '').length > 3 ? 'status__in' : 'status']: params?.status || '',
          page_size: params?.page_size || undefined,
          page: params?.page || undefined,
          id: params?.id || undefined,
        },
        url: '/orders/',
        method: 'GET',
      }),
      providesTags: ['Orders'],
    }),
    updateOrderStatus: build.mutation({
      query: (options: { body: TOrderUpdateStatusBody; id: string }) => {
        const { body, id } = options;
        return { url: `/users/change_order_status/${id}/`, method: 'PATCH', body };
      },
      invalidatesTags: ['Orders'],
    }),
    updateOrderData: build.mutation({
      query: (options: { body: FormData; id: string }) => ({
        url: `/users/change_order_data/${options.id}/`,
        method: 'PATCH',
        body: options.body,
      }),
      invalidatesTags: ['Orders'],
    }),
    getOrderFiles: build.query<{ files: TFile[] }, { id: string }>({
      query: (params) => ({
        url: `/orders/${params.id}/file/`,
        method: 'GET',
      }),
    }),
    exportOrders: build.query<string, IExportOrdersRequest>({
      query: (params) => ({
        url: '/orders/export/',
        method: 'GET',
        params: {
          date_from: params.date_from,
          date_to: params.date_to,
          payment_method: params.payment_method || undefined,
          currency: params.currency || undefined,
        },
        // ошибка приходит JSON-ом, файл — бинарём; object URL скачивает ExportOrders
        responseHandler: async (response) => {
          if (!response.ok) return response.json();
          const blob = await response.blob();
          return window.URL.createObjectURL(blob);
        },
      }),
    }),
  }),
});

export const {
  useGetOrdersQuery,
  useUpdateOrderStatusMutation,
  useUpdateOrderDataMutation,
  useGetOrderFilesQuery,
  useLazyExportOrdersQuery,
} = OrdersApi;
